import type { NehrAccessRestrictionState } from '@features/ConsentAndPermission/NehrAccessRestriction/types';

export const initialState: NehrAccessRestrictionState = {
  removeAccessFrom: [],
  shareAccessWith: [],
  videoWatched: false,
  declarationAcknowledged: false,
};
